import { render, staticRenderFns } from "./testTaker.vue?vue&type=template&id=245bd15c&scoped=true&"
import script from "./testTaker.vue?vue&type=script&lang=js&"
export * from "./testTaker.vue?vue&type=script&lang=js&"
import style0 from "./testTaker.vue?vue&type=style&index=0&id=245bd15c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245bd15c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('245bd15c')) {
      api.createRecord('245bd15c', component.options)
    } else {
      api.reload('245bd15c', component.options)
    }
    module.hot.accept("./testTaker.vue?vue&type=template&id=245bd15c&scoped=true&", function () {
      api.rerender('245bd15c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/testTaker/testTaker.vue"
export default component.exports